import { Skeleton, Stack } from '@mui/material'
import React from 'react'

const CustomLoading = () => {
  return (
    <Stack spacing={2}>
        <Skeleton variant="rounded"  height={100} />
        <Skeleton variant="rounded"  height={100} />
        <Skeleton variant="rounded"  height={100} />
        <Skeleton variant="rounded"  height={100} />
        <Skeleton variant="rounded"  height={100} />
      
    </Stack>
  )
}

export default CustomLoading